import React from 'react';

export default function Spinner({ label }) {
  return (
    <div className="app-loader" style={{ display: 'flex' }}>
      <div className="app-loader-card">
        <div className="app-loader-logo">
          <div className="gf-spinner">
            <div className="gf-ring gf-ring-1" />
            <div className="gf-ring gf-ring-2" />
            <div className="gf-ring gf-ring-3" />
            <div className="gf-ring gf-ring-4" />
            <div className="gf-core" />
          </div>
        </div>
        <div className="app-loader-text">
          <span className="app-loader-text-sweep">{label || 'Loading Data....'}</span>
        </div>
      </div>
    </div>
  );
}
